/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Generatekey3Inputs */

const en_settings_reportingapikeys_generatekey3 = /** @type {(inputs: Settings_Reportingapikeys_Generatekey3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate key`)
};

/**
* | output |
* | --- |
* | "Generate key" |
*
* @param {Settings_Reportingapikeys_Generatekey3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generatekey3 = /** @type {((inputs?: Settings_Reportingapikeys_Generatekey3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generatekey3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generatekey3(inputs)
});
export { settings_reportingapikeys_generatekey3 as "settings_reportingApiKeys_generateKey" }